import React, {PureComponent} from 'react'
import { Link, Redirect } from 'react-router-dom'
import { formPagePath } from '../utilities/route'
import NavBar from './navigation/nav-bar'
import Modal from 'reactstrap/lib/Modal'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalBody from 'reactstrap/lib/ModalBody'
import ModalFooter from 'reactstrap/lib/ModalFooter'
import Bg1 from '../images/parampage-bg1.png'
import Bg2 from '../images/parampage-bg2.png'
import "antd/lib/tree-select/style/css"
import { TreeSelect } from "antd"
import Button from './ui/button'
import { getAvailableThemes } from '../utilities/helpers'
import { isEmpty, isEqual } from 'lodash-es'

const RadioField = props => {
    const {label, children} = props;
    return (
        <div className="form-group row">
            {label && <div className="col-auto col-form-label">{label}</div>}
            <div className={label ? 'col-auto' : 'col'}>
                {children}
            </div>
        </div>
    )
}

const RadioFieldOption = props => {
    const {name, value, label, check, ...rest} = props;
    return (
        <div className="form-check form-check-inline">
            <label className="form-check-label">
                <input
                  className="form-check-input"
                  type={check ? 'checkbox' : 'radio'}
                  value={value}
                  checked={value}
                  name={name}
                  {...rest}
                />
                {label}
            </label>
        </div>
    )
}

class ParametersPage extends PureComponent {

  state = {
    chosenOptionIds: {},
    prefilledOptionIds: {},
    isConfirmDialogOpen: false,
    isPrivacyPolicyDialogOpen: false
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const { questionnaire: { parameters } } = this.props;
    const prefilledOptionIds = Object.fromEntries(
      parameters
        .filter(param => param.chosenOptionId !== null)
        .map(param => {
          return [param.value, param.chosenOptionId];
        })
    );
    if (Object.keys(prefilledOptionIds).length > 0) {
      this.setState({ chosenOptionIds: prefilledOptionIds, prefilledOptionIds });
    }
  }

  handlePolicyChange = () => {
    const {
      changeConsent,
      questionnaire: { isConsented, id },
      match: {
        params: {
          languageCode
        }
      }
    } = this.props;
    const variables = {
      id,
      consent: !isConsented,
      languageCode
    };
    return changeConsent({ variables });
  };

  handleFormButtonClick = () => {
    this.setState({
      isConfirmDialogOpen: true
    })
  }

  handleCorfirmButtonClick = () => {
    const {
      history,
      match: {
        params: { surveyId, languageCode },
      },
      questionnaire: {
        catalysts: surveyThemes,
        hideCatalystThemePages
      },
      goToQuestions,
      chooseRespondentParameterOptions,
      onSubmitError
    } = this.props;
    chooseRespondentParameterOptions({ variables: { parameterOptionIds: Object.values(this.state.chosenOptionIds) } })
      .then(() => goToQuestions({ variables: { languageCode} }))
      .then(() => {
        const availableThemes = getAvailableThemes(this.props.questionnaire.parameters, surveyThemes)
        if (hideCatalystThemePages) {
          history.push(formPagePath(languageCode, surveyId, 'catalyst', availableThemes[0].id, 'questions'));
        } else {
          history.push(formPagePath(languageCode, surveyId, 'catalyst', availableThemes[0].id));
        }
      })
      .catch((err) => {
        this.closeConfirmDialog()
        onSubmitError(err)
      })
  };

  renderForm() {
    const {
      useTranslate,
      questionnaire
    } = this.props;
    const enabled = (Object.keys(this.state.chosenOptionIds).length === questionnaire.parameters.length) && questionnaire.isConsented
    const onParameterOptionChange = (value, param) => {
      this.setState(prev => {
        return {
          chosenOptionIds: {
            ...prev.chosenOptionIds,
            [param.value]: value
          }
        }
      })
    }
    const t = (phrase) => useTranslate(`parameters.${phrase}`);
    return (
      <form>
        {questionnaire.parameters.map((param, index) => {
          return (
            <div key={index} className="form-group">
              <label>{param.label}</label>
              <TreeSelect
                style={{ width: "100%" }}
                dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                treeData={param.children}
                treeDefaultExpandAll
                treeCheckStrictly={true}
                showArrow={true}
                placeholder={t("select_menu_default_text")}
                value={this.state.chosenOptionIds[param.value]}
                onChange={(value) => onParameterOptionChange(value, param)}
              />
            </div>
          );
        })}
        <div className="separator mt-4 mb-3" />
        <RadioField>
          <RadioFieldOption
            check
            name="consent"
            value={questionnaire.isConsented}
            label={this.getPrivacyPolicyLabel()}
            onChange={this.handlePolicyChange}
          />
          {this.renderError()}
        </RadioField>
        <Button
          as="button"
          type="button"
          onClick={this.handleFormButtonClick}
          className={`mt-3 w-100 ${!enabled && "disabled"}`}
        >
          {t("parameters_submit_button")}
        </Button>
      </form>
    );
  }

  getPrivacyPolicyLabel() {
    const {
      useTranslate,
    } = this.props;
    const t = (phrase) => useTranslate(`parameters.${phrase}`);
    return (
      <span className="text-lg ml-2">
        {t("privacy_policy_checkbox_label")}
        <Link
          className="privacy-policy-read-more ml-2"
          to="#"
          onClick={(e) => { e.preventDefault(); this.openPrivacyPolicyDialog(); }}
        >
          {t("privacy_policy_link")}
        </Link>
      </span>
    );
  }

  renderConfirmContinue() {
    const {
      useTranslate,
    } = this.props;
    const t = (phrase) => useTranslate(`parameters.${phrase}`);
    const { chosenOptionIds, prefilledOptionIds } = this.state;
    const hasChangedFromPrefilled = !isEmpty(prefilledOptionIds) && !isEqual(chosenOptionIds, prefilledOptionIds);
    return (
      <Modal isOpen={this.state.isConfirmDialogOpen} toggle={this.closeConfirmDialog} className="modal-lg">
        <ModalHeader toggle={this.closeConfirmDialog}>
          {hasChangedFromPrefilled && t("confirm_dialog_title_options_changed")}
        </ModalHeader>
        <ModalBody>
          <div>{hasChangedFromPrefilled
            ? t("confirm_dialog_text_options_changed")
            : t("confirm_dialog_text_options_not_changed")
          }</div>
        </ModalBody>
        <ModalFooter>
          {hasChangedFromPrefilled && (
            <Button
              as={"button"}
              type="button"
              onClick={this.closeConfirmDialog}
              size={"md"}
              kind="gray"
            >
              {t("cancel")}
            </Button>
          )}
          <Button
            as={"button"}
            type="button"
            onClick={this.handleCorfirmButtonClick}
            size={"md"}
          >
            {t("continue")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  closeConfirmDialog = () => {
    this.setState({
      isConfirmDialogOpen: false
    })
  };

  renderPrivacyPolicy() {
    const {
      useTranslate
    } = this.props;
    const t = (phrase) => useTranslate(`privacy_policy.${phrase}`);
    return (
      <Modal isOpen={this.state.isPrivacyPolicyDialogOpen} toggle={this.closePrivacyPolicyDialog} className="modal-lg">
        <ModalHeader toggle={this.closePrivacyPolicyDialog}>{t("privacy_policy_title")}</ModalHeader>
        <ModalBody>
          <div
            className="privacy-policy-full"
            dangerouslySetInnerHTML={{ __html: t("privacy_policy_text") }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            as={"button"}
            type="button"
            onClick={this.closePrivacyPolicyDialog}
            size={"md"}
          >
            {t("accept")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  openPrivacyPolicyDialog = () => {
    this.setState({
      isPrivacyPolicyDialogOpen: true
    })
  };
  
  closePrivacyPolicyDialog = () => {
    this.setState({
      isPrivacyPolicyDialogOpen: false
    })
  };

  renderError() {
    const { submitError } = this.props;
    if (submitError) {
      if (process.env.NODE_ENV === "development") {
        return (
          <div className="btn-alert flex alert alert-danger questionnaire-error">
            {submitError.message}
          </div>
        );
      }
      return (
        <div className="btn-alert flex alert alert-danger questionnaire-error">
          Error submitting Parameters. Please try again later.
        </div>
      );
    }
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      useTranslate,
      questionnaire: {
        canAnswer,
        isAfterGameGuest
      }
    } = this.props;
    const t = (phrase) => useTranslate(`parameters.${phrase}`);
    // We redirect if aftergame is on
    if (!canAnswer || isAfterGameGuest) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }
    return (
      <section className="parameters-page app-page d-flex flex-column">
        <img className="bg1" src={Bg1} alt="Shapes" />
        <img className="bg2" src={Bg2} alt="Shapes" />
        <NavBar renderClose inverse />
        {this.renderPrivacyPolicy()}
        {this.renderConfirmContinue()}
        <div>
          <div className="card card-block mt-5">
            <div className="card-body">
              <div>
                <h1 className="card-title">{t("parameters_page_title")}</h1>
              </div>
              <div className="description text-lg mb-4">{t("parameters_page_description")}</div>
              {this.renderForm()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ParametersPage



// WEBPACK FOOTER //
// ./src/components/parameters-page.js